import { useMutation, useQueryClient } from 'react-query';

import { makeUpdateCustomerPhoneUseCase } from 'modules/authentication/domain/useCases';
import { useAuth } from 'modules/authentication/presentation/contexts';
import { customerQueries } from 'modules/customer/presentation/constants';
import { useCustomer } from 'modules/customer/presentation/hooks';
import { useRequestErrorHandler } from 'shared/presentation/hooks';

export default function useMandatoryPhoneGate() {
  const auth = useAuth();
  const client = useQueryClient();
  const { handleError } = useRequestErrorHandler('authentication');

  const { customer, loading } = useCustomer();

  const mutation = useMutation(
    (phone: string) => {
      if (!auth.session) return Promise.reject(new Error('No active session'));

      return makeUpdateCustomerPhoneUseCase().execute({
        customerId: auth.session.id,
        phone,
      });
    },
    {
      onSuccess: () =>
        client.invalidateQueries(customerQueries.customer(auth.session?.id)),
      onError: error => handleError(error),
    },
  );

  return {
    loading,
    shouldBlock: !!customer && !customer.phone,
    updating: mutation.isLoading,
    updatePhone: mutation.mutate,
  };
}
